var ProgressStepStatus;
(function (ProgressStepStatus) {
    ProgressStepStatus["COMPLETE"] = "complete";
    ProgressStepStatus["IN_PROGRESS"] = "current";
    ProgressStepStatus["INCOMPLETE"] = "incomplete";
})(ProgressStepStatus || (ProgressStepStatus = {}));
var InProgressDisplayColor;
(function (InProgressDisplayColor) {
    InProgressDisplayColor["DEFAULT"] = "default";
    InProgressDisplayColor["ORANGE"] = "orange";
})(InProgressDisplayColor || (InProgressDisplayColor = {}));
var ProgressStepsStyle;
(function (ProgressStepsStyle) {
    ProgressStepsStyle["PRIMARY"] = "primary";
    ProgressStepsStyle["GREEN"] = "green";
})(ProgressStepsStyle || (ProgressStepsStyle = {}));

export { InProgressDisplayColor, ProgressStepStatus, ProgressStepsStyle };
